import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type GenerateCheckPdfParams = {
  paymentIds: string[];
};

export const generateCheckPdfAtom = createMutationAtomFactory(
  'finance.generateCheckPdf',
  (params: GenerateCheckPdfParams) => ({
    financeGenerateCheckPdf: {
      __args: {
        paymentIds: params.paymentIds,
      },
      fileId: true,
    },
  }),
);
